import { KeyboardShortcutName } from '../../../cross-team-shared/misc-services/keyboard-shortcut.service';
import { outputShortcuts } from './output-shortcuts';

export const outputShortcuts2d: KeyboardShortcutName[] = [
  ...outputShortcuts,
  'altDown',
  'altUp',
  'copySelectedShapes',
  'copySelectedShapesAllFrames',
  'decreaseBrightness',
  'decreaseContrast',
  'increaseBrightness',
  'increaseContrast',
  'moveSliderLeft',
  'moveSliderLeftSlow',
  'moveSliderRight',
  'moveSliderRightSlow',
  'panDown',
  'panLeft',
  'panRight',
  'panUp',
  'pasteShapes',
  'undo',
  'undoSubpoint',
  'selectZoomTool',
  'selectSliderRectangleTool',
  'selectKeypointTool',
  'selectLineTool',
  'selectPointTool',
  'selectPolygonTool',
  'selectRectangleTool',
  'selectArrowTool',
];
